import { Link, Route } from "react-router-dom";
import Layout from "./Layout";
import Quotations from "./pages/Quotations";
import { loadQuotations, loadSalesOrder, loadOrderToInvoice, loadSalesOrders } from "./apis/salesOrderAPI";
import SalesOrders from "./pages/SalesOrders";
import SalesOrderChanges from "./pages/SalesOrderChanges";
import SalesTeams from "./pages/SalesTeams";
import { loadSalesTeam, loadSalesTeams } from "./apis/salesTeamAPI";
import SalesTeamChanges from "./pages/SalesTeamChanges";
import SalesToInvoice from "./pages/SalesToInvoice";
import Products from './pages/Products';
import ProductChanges from './pages/ProductChanges';
import { loadProduct, loadProducts } from "./apis/productAPI";
import Contacts from "./pages/Contacts";
import { loadContact, loadContacts, loadContactsForSell } from "./apis/contactsAPI";
import ContactChanges from "./pages/ContactChanges";
import PoS from "./pages/PoS";
import PosChanges from "./pages/PosChanges";
import { loadOnePos, loadPoS, loadPos } from "./apis/posAPI";
import DeliveryRegions from "./pages/DeliveryRegions";
import DeliveryRegionChanges from "./pages/DeliveryRegionChanges";
import PaymentMethods from "./pages/PaymentMethods";
import PaymentMethodChanges from "./pages/PaymentMethodChanges";
import { loadDeliveryRegion, loadDeliveryRegions } from "./apis/deliveryRegionAPI";
import { loadPaymentMethod, loadPaymentMethods } from "./apis/paymentMethodAPI";
import Overview from "./Overview";
import SellPage from "./pages/SellPage";
import Customers from "./pages/Customers";
import ProductPage from "./components/ProductPage";
import PosMakPayment from "./pages/PosMakPayment";
import { loadPickLaterOrders, loadPosOrder, loadPosOrders, loadPosPaymentMethods, loadPosSessionOrder, loadPosSessionOrders, loadSessionOrders } from "./apis/posOrderAPI";
import PosSessionOrders from "./pages/PosSessionOrders";
import PaymentSuccess from "./pages/PaymentSuccess";
import PosSessionLists from "./pages/PosSessionLists";
import { loadSession, loadSessionPayments, loadSessions, loadSessionTransfers } from "./apis/sessionAPI";
import PosOrders from "./pages/PosOrders";
import PosChooseCashier from "./pages/PosChooseCashier";
import PosSessionLayout from "./PosSessionLayout";
import PosLayout from "./PosLayout";
import PosSalesUpdate from "./pages/PosSalesUpdate";
import { loadPosSalesUpdate, loadPosSaleUpdate } from "./apis/posSalesUpdateAPI";
import PosSalesUpdateChanges from "./pages/PosSalesUpdateChanges";
import Dashboard from "./Dashboard";
import PosSessionCustomers from "./pages/PosSessionCustomers";
import PosSessionCustomerChanges from "./pages/PosSessionCustomerChanges";
import Settings from "./pages/Settings";
import { loadSettings } from "./apis/settingAPI";
import PosOrderChanges from "./pages/PosOrderChanges";
import PosSessionChanges from "./pages/PosSessionChanges";
import PosSessionTransfers from "./pages/PosSessionTransfers";
import PosSessionPayments from "./pages/PosSessionPayments";
import PosOrderReprintPage from "./pages/PosOrderReprintPage";



const salesRouter = () => (
  <>
  <Route path="/sales" element={<Layout />} handle={{ crumb: () => <Link to={'/sales'}>Overview</Link>}}>
    <Route index element={<Quotations />} loader={loadQuotations} />
    <Route path="quotation" element={<Quotations />} loader={loadQuotations} handle={{ crumb: () => <Link>Quotations</Link>}} />
    <Route path="orders" element={<SalesOrders />} loader={loadSalesOrders} />
    <Route path="orders/:action" element={<SalesOrderChanges />} loader={params => loadSalesOrder(params.params.action)} />
    <Route path="to-invoice" element={<SalesToInvoice />} loader={loadOrderToInvoice} />
    <Route path="teams" element={<SalesTeams />} loader={loadSalesTeams} />
    <Route path="teams/:action" element={<SalesTeamChanges />} loader={params => loadSalesTeam(params.params.action)} />
    <Route path="products" element={<Products />} loader={loadProducts} handle={{ crumb: () => <Link>Products</Link>}} />
    <Route path="products/:action" element={<ProductChanges />} loader={params => loadProduct(params.params.action)} handle={{ crumb: (data) => <span><Link to={'/sales/products'}>Products</Link> / {data.product?.name}</span>}} />
    <Route path="customers" element={<Contacts />} loader={loadContacts} />
    <Route path="customers/:action" element={<ContactChanges />} loader={params => loadContact(params.params.action)} />

    
    
  </Route>


  <Route path="pos" element={<PosLayout />}>
    <Route index element={<Overview />} loader={loadPos}/>
    <Route path="dashboard" element={<Dashboard />} />
    <Route path="customers" element={<Customers />} loader={loadContacts} />
    <Route path="sales-update" element={<PosSalesUpdate />} loader={loadPosSalesUpdate} />
    <Route path="sales-update/:action" element={<PosSalesUpdateChanges />} loader={params => loadPosSaleUpdate(params.params.action)} />
    <Route path="pos-sessions" element={<PosSessionLists />} loader={loadSessions} />
    <Route path="pos-sessions/:action" element={<PosSessionChanges />} loader={params => loadSession(params.params.action)} />
    <Route path="pos-sessions/:action/orders" element={<PosOrders />} loader={params => loadSessionOrders(params.params.action)} />
    <Route path="pos-sessions/:action/transfers/" element={<PosSessionTransfers />} loader={params => loadSessionTransfers(params.params.action)} />
    <Route path="pos-sessions/:action/payments" element={<PosSessionPayments />} loader={params => loadSessionPayments(params.params.action)} />
    <Route path="pos-orders" element={<PosOrders />} loader={loadPosOrders} />
    <Route path="pos-pick-laters" element={<PosOrders />} loader={loadPickLaterOrders} />
    <Route path="pos-orders/:action" element={<PosOrderChanges />} loader={params => loadPosOrder(params.params.action)} />
    <Route path="point-of-sales" element={<PoS />} loader={loadPoS} />
    <Route path="point-of-sales/:action" element={<PosChanges />} loader={params => loadOnePos(params.params.action)} />
    <Route path="delivery-regions" element={<DeliveryRegions />} loader={loadDeliveryRegions} />
    <Route path="delivery-regions/:action" element={<DeliveryRegionChanges />} loader={params => loadDeliveryRegion(params.params.action)} />
    <Route path="payment-methods" element={<PaymentMethods />} loader={loadPaymentMethods} />
    <Route path="payment-methods/:action" element={<PaymentMethodChanges />} loader={params => loadPaymentMethod(params.params.action)} />
    <Route path="products" element={<Products />} loader={loadProducts} handle={{ crumb: () => <Link>Products</Link>}} />
    <Route path="settings" element={<Settings />} loader={loadSettings} />
  </Route>

  <Route path="pos/session" element={<PosSessionLayout />} >
    <Route index element={<PosChooseCashier />} />

    <Route path="sells" element={<SellPage />}>
      <Route index element={<ProductPage />} />
      <Route path="customers" element={<PosSessionCustomers />} loader={loadContactsForSell} />
      <Route path="customers/:action" element={<PosSessionCustomerChanges />} loader={params => loadContact(params.params.action)} />
      <Route path="session-orders" element={<PosSessionOrders />} />
    </Route>
    <Route path="order/payment/:action" element={<PosMakPayment />} loader={params => loadPosPaymentMethods(params.params.action)} />
    <Route path="order/payment-sucess" element={<PaymentSuccess />} />
    <Route path="order/reprint" element={<PosOrderReprintPage />} />
  </Route>
  
  </>
);


export default salesRouter;